import { SILENCE_ABORT_MS, SseResponseError, SseSilenceError } from './sse';

/** Message honnête affiché quand le chat échoue sans cause identifiable côté
 *  client — ne jamais inventer de cause ("un outil est en panne", "le serveur
 *  est surchargé") qu'on n'a pas vérifiée. */
export const CHAT_GENERIC_ERROR = 'Un problème est survenu. Réessaie dans un instant.';
const CHAT_SESSION_EXPIRED_ERROR = 'Ta session a expiré. Reconnecte-toi pour continuer.';
const CHAT_VALIDATION_ERROR = "Naïa n'a pas pu traiter cette demande. Essaie de la reformuler.";
const CHAT_NETWORK_ERROR = 'La connexion a été interrompue. Réessaie dans un instant.';
export const CHAT_SLOW_NOTICE = 'Naïa met plus de temps que d’habitude. Patiente encore un peu ou réessaie.';
export const CHAT_SILENCE_ERROR = `Naïa n’a pas répondu depuis plus de ${SILENCE_ABORT_MS / 1000} secondes.`;
const CHAT_ATTACHMENT_UPLOAD_ERROR = "L'envoi du fichier a échoué. Réessaie dans un instant.";

const isNetworkError = (err: Error): boolean =>
  err.message === 'sse-read-timeout'
  || err.name === 'TypeError'
  || /failed to fetch|network|load failed/i.test(err.message);

/**
 * Traduit une erreur de chat (réseau, HTTP, ou événement `error` du flux SSE)
 * en un message français lisible, jamais le JSON/texte brut d'une réponse
 * serveur. Les messages déjà rédigés pour l'utilisateur (erreurs métier
 * typées, cas `__write_partial__` géré par l'appelant) passent par leur propre
 * chemin et n'appellent pas cette fonction.
 */
export function chatErrorMessage(err: unknown): string {
  if (!(err instanceof Error)) return CHAT_GENERIC_ERROR;
  if (err instanceof SseResponseError) {
    if (err.status === 401 || err.status === 403) return CHAT_SESSION_EXPIRED_ERROR;
    if (err.status === 400) return CHAT_VALIDATION_ERROR;
    return CHAT_GENERIC_ERROR;
  }
  if (err instanceof SseSilenceError) return CHAT_SILENCE_ERROR;
  if (isNetworkError(err)) return CHAT_NETWORK_ERROR;
  return CHAT_GENERIC_ERROR;
}

/** Même garde que `chatErrorMessage`, pour l'échec d'un envoi de pièce jointe —
 *  l'erreur peut venir d'un upload PUT brut ou d'une mutation tRPC, jamais
 *  rédigée pour l'utilisateur dans les deux cas. */
export function chatAttachmentErrorMessage(err: unknown): string {
  if (err instanceof Error && isNetworkError(err)) return CHAT_NETWORK_ERROR;
  return CHAT_ATTACHMENT_UPLOAD_ERROR;
}
